module.exports = __webpack_public_path__ + "img/icon-16-filter.6552136a.svg";